import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import { Col, Container, Row, Card, CardBody, Button } from 'reactstrap';
import history from '../../../../history';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

const renderField = ({
    input, disabled, placeholder, type, meta: { touched, error }, style
  }) => (
    <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above" style={style}>
      <input {...input} placeholder={placeholder} type={type} disabled={disabled}/>
      {touched && error && <span className="form__form-group-error">{error}</span>}
    </div>
  );
  
  renderField.propTypes = {
    input: PropTypes.shape().isRequired,
    placeholder: PropTypes.string,
    type: PropTypes.string,
    meta: PropTypes.shape({
      touched: PropTypes.bool,
      error: PropTypes.string,
    }),
  };
  
  renderField.defaultProps = {
    placeholder: '',
    meta: null,
    type: 'text',
  };

const AddProfile = () => {
        const [ profile, setProfile ] = useState('');
        const [ code, setCode ] = useState('');
        const [ errors, setErrors ] = useState({});

        const validate = () => {
            var newErrors = {};
            if(!profile){
                newErrors.profile = "Ingrese un perfil";
            } else {
                delete  newErrors.profile;
            }
            
            if(!code){
                newErrors.code = "Ingrese un codigo";
            } else {
                delete  newErrors.code;
            }

            setErrors(newErrors);
            if(Object.keys(newErrors).length > 0){
                return true;
            } else {
                return false;
            }
        }

        const createProfile = async () => {
            if(!validate()){
                var data = {
                    nombre: profile,
                    codigo: code
                };
    
                await fetch( process.env.REACT_APP_PUBLIC_URL + 'perfiles/create',  
                 {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                      'authorization': 'Bearer ' + sessionStorage.getItem('token'), 
                      },
                    body: JSON.stringify(data)
                  })
                  .then(response => {
                    return response.text();
                  })
                  .then(data => {                    
                    alert("Perfil creado correctamente");
                    history.push({
                        pathname: process.env.PUBLIC_URL +'/config/manage-profile',                        
                      });
                  })
                  .catch((error) => {
                    console.error('Error:', error);
                  });
            }
        }

        return (<Container className="dashboard">
                    <Row>
                        <Col md={12}>
                            <h3 style={{ marginBottom: 30 }}>Crear Perfil</h3>
                            <Button
                            style={{ marginBottom: 20 }}
                            color="primary"
                            size="sm"
                            onClick={() => {
                                history.push({
                                    pathname: process.env.PUBLIC_URL + '/config/manage-profile'
                                });
                            }}
                        >
                            <ArrowBackIcon />
                        </Button>
                        </Col>
                    </Row>
                    <Row>
                        <Card>
                            <CardBody style={{ margin: 'auto' }}>
                                <div className="form" style={{ display: 'inline' }}>
                                    <div className="form__form-group">
                                        <span className="form__form-group-label">Nombre Perfil</span>
                                        <div className="form__form-group-field">
                                            <Field
                                                key={`profile`}
                                                name={`profile`}
                                                component={renderField}
                                                type="text"
                                                placeholder={''}
                                                value={profile}
                                                onChange={(e) => {
                                                    setProfile(e.target.value)
                                                }}
                                                meta={{ touched: errors.hasOwnProperty("profile") , error: errors.hasOwnProperty("profile")? errors.profile: ""}}
                                                style={{ width: 400 }}
                                            />
                                        </div>
                                    </div>
                                    <div className="form__form-group">
                                        <span className="form__form-group-label">Codigo</span>
                                        <div className="form__form-group-field">
                                            <Field
                                                name="code"
                                                component={renderField}
                                                type='text'
                                                placeholder=""
                                                value={code}
                                                onChange={(e) => {
                                                    setCode(e.target.value);
                                                }}
                                                meta={{ touched: errors.hasOwnProperty("code") , error: errors.hasOwnProperty("code")? errors.code: ""}}
                                            />
                                    </div>
                                </div>
                                </div>
                                <Button 
                                    style={{marginTop: 20}}                                    
                                    color="primary" 
                                    onClick={() => {
                                        createProfile();
                                    }}
                                >
                                    Agregar
                                </Button>
                            </CardBody>
                        </Card>
                    </Row>
                </Container>);
}

export default reduxForm({
    form: 'add_profile_form', // a unique identifier for this form
})(withTranslation('common')(AddProfile));